//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import ReactGA from 'react-ga';
import sha256 from 'crypto-js/sha256';

//components
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';
import LanguageTabs from '../../components/languageTabs/languageTabs';
import PageRequestValidator from '../../components/pageRequestValidator/pageRequestValidator';
import PopupLogin from '../../components/popup/login';
import Translation from '../../components/translation/translation';

//data
import dataSiteMap from '../../siteMap.json';
import dataTranslations from './translations.json';

//assets
import './landingPage.css';

//functions
import * as Utilities from '../../utilities';

class LandingPage extends Component {
	constructor() {
		super();

		this.state = {
			languageIndex: 0,
			loggedIn: {},
			loginShow: false,
			playing: false,
		};

		this.closeLogin = this.closeLogin.bind(this);
		this.loginPopup = this.loginPopup.bind(this);
		this.openLogin = this.openLogin.bind(this);
		this.playVideo = this.playVideo.bind(this);
		this.changeLanguage = this.changeLanguage.bind(this);
		this.setUserTypePreferenceCookie = this.setUserTypePreferenceCookie.bind(this);
	}

	componentDidMount() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;

		this.checkLogin();
	}

	componentWillReceiveProps() {
		this.setState({
			languageIndex: 0,
			playing: false,
		});

		this.refs.landingVideo.pause();
		this.refs.landingVideo.currentTime = 0;
	}

	componentDidUpdate() {
		this.checkLogin();
	}

	checkLogin() {
		const culture = this.props.match.params.culture;
		const loggedIn = this.state.loggedIn;

		if (dataSiteMap[culture]) {
			if (dataSiteMap[culture].hcpLogin && !this.state.loggedIn[culture]) {
				const key1 = window.sessionStorage.getItem(culture + 'Key1');
				const key2 = window.sessionStorage.getItem(culture + 'Key2');

				if (key1 === sha256(dataSiteMap[culture].hcpLogin[dataSiteMap[culture].hcpLogin.length - 1].key1).toString() && key2 === sha256(dataSiteMap[culture].hcpLogin[[dataSiteMap[culture].hcpLogin.length - 1]].key2).toString()) {
					loggedIn[culture] = true;

					this.setState({
						loggedIn: loggedIn,
					});
				}
			}
		}
	}

	playVideo() {
		this.refs.landingVideo.play();

		this.setState({
			playing: true,
		});

		ReactGA.event({
			category: 'video',
			action: 'play',
			label: 'landingPage',
		});
	}

	openLogin() {
		this.setState({
			loginShow: true,
		});
	}

	closeLogin(event, preventDefault) {
		if (preventDefault) {
			event.preventDefault();
		}

		this.setState({
			loginShow: false,
		});
	}

	loginPopup(culture) {
		if (this.state.loginShow) {
			return (
				<PopupLogin close={this.closeLogin} culture={culture} login={this.props.login} url={'/' + culture + '/hcp/' + dataSiteMap[culture].navigation['hcp'].pages.filter(({live}) => live === true)[0].key} />
			);
		}

		return null;
	}

	changeLanguage(languageIndex) {
		this.setState({
			languageIndex: languageIndex,
			playing: false,
		});

		this.refs.landingVideo.pause();
		this.refs.landingVideo.currentTime = 0;
	}

	setUserTypePreferenceCookie(culture) {
		// only set cookie if UK
		if (culture === 'uk') {
			const today = new Date();
			let expire = new Date();
	
			expire.setTime(today.getTime() + 3600000 * 24 * 14);
			document.cookie = 'userTypePreference=true;expires=' + expire.toGMTString() + ';path=/';
		}
	}

	render() {
		const culture = this.props.match.params.culture;
		const cultureFallback = 'uk'; //UK set as the default culture

		let videoLabel = dataTranslations[cultureFallback].videos[0].videoLabel;
		let videoPath = dataTranslations[cultureFallback].videos[0].videoPath;

		if (dataTranslations[culture]) {
			if (dataTranslations[culture].videos[this.state.languageIndex]) {
				if (dataTranslations[culture].videos[this.state.languageIndex].videoLabel) {
					videoLabel = dataTranslations[culture].videos[this.state.languageIndex].videoLabel;
				}

				if (dataTranslations[culture].videos[this.state.languageIndex].videoPath) {
					videoPath = dataTranslations[culture].videos[this.state.languageIndex].videoPath;
				}
			}
		}

		let videoStyle = 'landing-page__video';

		if (this.state.playing) {
			videoStyle += ' landing-page__video--playing';
		}

		Utilities.setLanguage(culture);
		Utilities.setAlternatePageLinks(culture);

		return (
			<div className="wrapper">

				<PageRequestValidator culture={culture} />

				<DocumentMeta {...Utilities.getMeta(culture)} />

				<Header culture={culture} />

				{culture !== 'global' && dataSiteMap[culture] &&
					<section className="landing-page">
						<div className="container">
							<div className="container__row">
								<div className="container__column container__column--half container__column--top">
									<h1 className="landing-page__title"><Translation culture={culture} data={dataTranslations} name="title" /></h1>
									<LanguageTabs changeLanguage={this.changeLanguage} culture={culture} languageIndex={this.state.languageIndex} translations={dataTranslations[culture].videos} />
									<div className={videoStyle}>
										<video className="landing-page__video__player" controls controlsList="nodownload" playsInline ref="landingVideo" src={process.env.PUBLIC_URL + videoPath} />
										<button className="landing-page__video__poster" onClick={() => this.playVideo()}>
											<div className="landing-page__video__poster__inner">
												<div className="landing-page__video__poster__inner__text hwa">
													<div className="landing-page__video__poster__inner__text__inner">{videoLabel}</div>
												</div>
											</div>
										</button>
									</div>
								</div>
								<div className="container__column container__column--half container__column--bottom">
									{dataSiteMap[culture].hcpLogin && !this.state.loggedIn[culture] ?
										<button className="landing-page__button hwa" onClick={() => this.openLogin(dataSiteMap[culture].hcpLoginType)}>
											<h2 className="landing-page__button__title"><Translation culture={culture} data={dataTranslations} name="hcpTitle" /></h2>
											<p className="landing-page__button__body"><Translation culture={culture} data={dataTranslations} name="hcpBody" /></p>
										</button>
									:
										<Link className="landing-page__button hwa" hrefLang={dataSiteMap[culture].cultureCode} onClick={() => this.setUserTypePreferenceCookie(culture)} to={'/' + culture + '/hcp/' + dataSiteMap[culture].navigation['hcp'].pages.filter(({live}) => live === true)[0].key}>
											<h2 className="landing-page__button__title"><Translation culture={culture} data={dataTranslations} name="hcpTitle" /></h2>
											<p className="landing-page__button__body"><Translation culture={culture} data={dataTranslations} name="hcpBody" /></p>
										</Link>
									}
									<Link className="landing-page__button landing-page__button--public hwa" hrefLang={dataSiteMap[culture].cultureCode} onClick={() => this.setUserTypePreferenceCookie(culture)} to={'/' + culture + '/public/' + dataSiteMap[culture].navigation['public'].pages.filter(({live}) => live === true)[0].key}>
										<h2 className="landing-page__button__title"><Translation culture={culture} data={dataTranslations} name="publicTitle" /></h2>
										<p className="landing-page__button__body"><Translation culture={culture} data={dataTranslations} name="publicBody" /></p>
									</Link>
								</div>
							</div>
							<p className="landing-page__body"><Translation culture={culture} data={dataTranslations} name="body" /></p>
						</div>
					</section>
				}

				<Footer culture={culture} />

				{this.loginPopup(culture)}

			</div>
		);
	}
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/landingPage/landingPage.js